import type { ChainEnum } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';
import type {
  CryptoDotComPaymentCreateRequest,
  CryptoDotComPaymentResponse,
} from '../cryptoDotCom.types';

/**
 * Creates a crypto.com payment
 *
 * @param paymentParams CryptoDotComPaymentCreateRequest - The parameters for the payment.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns The created payment
 */
export const createCryptoDotComPayment = async (
  paymentParams: CryptoDotComPaymentCreateRequest,
  client = getDefaultClient()
): Promise<CryptoDotComPaymentResponse> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  const response = await apiClient.createCryptoDotComPayment({
    cryptoDotComPaymentCreateRequest: {
      ...paymentParams,
      // eslint-disable-next-line custom-rules/ban-chain-enum
      chain: paymentParams.chain as ChainEnum,
    },
    environmentId: core.environmentId,
  });

  return response;
};
